module.exports = __webpack_public_path__ + "static/media/login_signin.85997f65.png";